import React from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';

const GoogleRecaptcha = ({ googleRecaptchaSiteKey, onValidGoogleRecaptcha }) => (
  <ReCAPTCHA
    sitekey={`${googleRecaptchaSiteKey}`}
    onChange={onValidGoogleRecaptcha}
  />
);

GoogleRecaptcha.propTypes = {
  onValidGoogleRecaptcha: PropTypes.func.isRequired,
  googleRecaptchaSiteKey: PropTypes.string
};

GoogleRecaptcha.defaultProps = {
  googleRecaptchaSiteKey: '6LeDZ08UAAAAAJy19W0APwhf6UKQJ_nIqG37Kuhu'
};

export default GoogleRecaptcha;
